import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { CommonComponentProps } from "./componentTypes";

interface MutedTextProps
  extends HTMLAttributes<HTMLParagraphElement>,
    CommonComponentProps {}

export function MutedText({ children, className, ...rest }: MutedTextProps) {
  return (
    <p
      className={cx(
        "font-sans text-body font-normal text-muted-foreground",
        className
      )}
      {...rest}
    >
      {children}
    </p>
  );
}
